import { useState } from 'react'
import { Alert, Container, Paper, Typography } from '@mui/material'
import Wrapper from '../components/Wrapper'
import AccreditationForm from '../components/AccreditationForm'
import TermsWizard from '../components/TermsWizard'
import { useSessionStore } from '../state'

const AccreditationSubmission = () => {
  const accreditation = useSessionStore(s => s.profile?.accreditation)
  const [wizardComplete, setWizardComplete] = useState(false)

  const renderContent = () => {
    if (!accreditation || accreditation.status === 'rejected') {
      if (!wizardComplete) {
        return <TermsWizard onComplete={() => setWizardComplete(true)} />
      }

      if (!accreditation) {
        return <AccreditationForm mode='submit' />
      }

      return (
        <>
          <Alert severity='warning' sx={{ mb: 3 }}>
            Your previous accreditation submission was rejected. Please review
            the information below and resubmit.
          </Alert>
          <AccreditationForm mode='resubmit' />
        </>
      )
    }

    switch (accreditation.status) {
      case 'pending':
        return (
          <Alert severity='info'>
            Your accreditation submission is currently under review. You cannot
            submit a new request until the current one has been reviewed.
          </Alert>
        )
      case 'verified':
        return (
          <Alert severity='success'>
            Your accreditation has been verified. You are a verified diver on
            the platform.
          </Alert>
        )
      default:
        return <AccreditationForm mode='submit' />
    }
  }

  return (
    <Wrapper>
      <Container maxWidth='sm'>
        <Paper sx={{ p: 3, mt: 2 }}>
          <Typography variant='h5' gutterBottom>
            Diver Accreditation
          </Typography>
          {renderContent()}
        </Paper>
      </Container>
    </Wrapper>
  )
}

export default AccreditationSubmission
